define('core/post-process',["exports", "core/pubsubhub"], function (exports, _pubsubhub) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.done = exports.name = undefined;
  const name = exports.name = "core/post-process"; /**
                                                    * Module core/post-process
                                                    *
                                                    * Corresponds to respecConfig.postProcess and config.afterEnd.
                                                    *  - postProcess: an array of functions that get called
                                                    *      after processing finishes. This is not recommended and the feature is not
                                                    *      tested. Use with care, if you know what you're doing. Chances are you really
                                                    *      want to be using a new module with your own profile.
                                                    *  - afterEnd: final thing that is called.
                                                    */


  let doneResolver;
  const done = exports.done = new Promise(resolve => {
    doneResolver = resolve;
  });

  (0, _pubsubhub.sub)("plugins-done", async config => {
    const result = [];
    if (Array.isArray(config.postProcess)) {
      const values = await Promise.all(config.postProcess.filter(f => typeof f === "function").map(f => Promise.resolve(f(config, document))));
      result.push(...values);
    }
    if (typeof config.afterEnd === "function") {
      result.push((await Promise.resolve(config.afterEnd(config, document))));
    }
    doneResolver(result);
  }, { once: true });
});
//# sourceMappingURL=post-process.js.map;
